export const findValidDependancyOptions = (plan, targetBenefitId) => {
  let dependancyOptions = [];

  if (!plan) {
    return dependancyOptions;
  }

  let objectWithOptions;

  if (plan.options && plan.options.length > 0) {
    // Find selected option:
    const selectedOption = plan.options.find(option => option.isAvailable && option.isSelected);

    objectWithOptions = selectedOption;
  } else {
    objectWithOptions = plan;
  }

  if (!objectWithOptions || !objectWithOptions.dependancyOptions) {
    objectWithOptions = plan;

    if (!objectWithOptions || !objectWithOptions.dependancyOptions) {
      return dependancyOptions;
    }
  }

  if (
    !Array.isArray(objectWithOptions.dependancyOptions) &&
    objectWithOptions.dependancyOptions.dependancyOption
  ) {
    dependancyOptions = objectWithOptions.dependancyOptions.dependancyOption;
  }

  if (Array.isArray(objectWithOptions.dependancyOptions)) {
    const validOptions = objectWithOptions.dependancyOptions.find(
      option => {
        if (plan.intervalOptions) {
          return (
            option.benefitID === targetBenefitId &&
            // Use sumAssured to accurately compare with planValue in dependencyOptions
            option.planValue === plan.sumAssured
          );
        }

        // Normal plan without interval
        return option.benefitID === targetBenefitId;
      } //&&
      // get the dependancyOption based on selected planId
      //option.optionID === plan.planId
    );

    if (validOptions && validOptions.dependancyOption) {
      dependancyOptions = validOptions.dependancyOption;
    }
  }

  return dependancyOptions;
};



// WEBPACK FOOTER //
// ./reducers/utils/riskmedicalDependancyOptionUtils.js